import { DocumentViewerToolbarOptionsModel, DocumentExportOptionsModel } from '@/types';

export const DocumentViewerConstants = {
  DocumentViewerDeletePageToolOptions: {
    allowPageNavigation: true,
    allowPageDelete: true,
    allowDocumentDelete: false,
    pageDeleteNotAllowedTooltip: '',
    documentDeleteNotAllowedTooltip: 'Document cannot be deleted here',
    showEditReferences: false
  } as DocumentViewerToolbarOptionsModel,

  DocumentViewerDeleteDisabledToolOptions: {
    allowPageNavigation: true,
    allowPageDelete: false,
    allowDocumentDelete: false,
    pageDeleteNotAllowedTooltip: 'Page cannot be deleted here',
    documentDeleteNotAllowedTooltip: 'Document cannot be deleted here',
    showEditReferences: false
  } as DocumentViewerToolbarOptionsModel,

  DocumentViewerDeleteEnabledToolOptions: {
    allowPageNavigation: true,
    allowPageDelete: true,
    allowDocumentDelete: true,
    pageDeleteNotAllowedTooltip: '',
    documentDeleteNotAllowedTooltip: '',
    showEditReferences: false
  } as DocumentViewerToolbarOptionsModel,

  PageDisabledOutsideStoreToolOptions: {
    allowPageNavigation: true,
    allowPageDelete: false,
    pageDeleteNotAllowedTooltip: 'Can only delete pages once Store has been selected',
    allowDocumentDelete: true,
    documentDeleteNotAllowedTooltip: '',
    showEditReferences: false
  } as DocumentViewerToolbarOptionsModel,

  WithoutAcquiringLockExportOptions: {
    HistoryDescription: '',
    AcquireDocumentLock: false
  } as DocumentExportOptionsModel,

  DefaultLockExportOptions: {
    HistoryDescription: '',
    AcquireDocumentLock: true
  } as DocumentExportOptionsModel
};
